import { render, staticRenderFns } from "./links-block.vue?vue&type=template&id=f1274adc&scoped=true&functional=true"
var script = {}
import style0 from "./links-block.vue?vue&type=style&index=0&id=f1274adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f1274adc",
  null
  
)

export default component.exports